
export default function ManageInviteViewRevokeModalController($scope, $uibModalInstance, invite, manageInvitesRepository, gettextCatalog) {
    
    'ngInject';
    
    $scope.invite = invite;
    $scope.loading = false;
    $scope.errorFlag = false;
    $scope.errorText = "";

    $scope.ok = function () {
        $scope.errorFlag = false;
        $scope.loading = true;
        manageInvitesRepository.deleteInviteByEmail($scope.invite.email)
            .then(function (response) {
                $uibModalInstance.close();
            })
            .catch(function (error) {
                var errorMsg = gettextCatalog.getString("An error occurred while revoking the invite. Please try again later.");
                if (!!error) {
                    if (!!error.data && !!error.data.message && !!error.status && !!error.statusText) {
                        errorMsg = error.data.message + " " + (error.status.toString() + " - " + error.statusText.toString());
                    }
                    else if (!!error.status && !!error.statusText) {
                        errorMsg = gettextCatalog.getString("An error occurred while revoking the invite: ") + (error.status.toString() + " - " + error.statusText.toString());
                    }
                }
                $scope.errorText = errorMsg;
                $scope.errorFlag = true;
            })
            .finally(function () {
                $scope.loading = false;
            });
    };

    $scope.cancel = function () {
        $uibModalInstance.dismiss('cancel');
    };

    $scope.$on('$locationChangeStart', function (event, next, current) {
        $scope.cancel();
        event.preventDefault();
    });
}
